import React from 'react';
import {
  Card, Form, Row, Col, Button,
} from 'react-bootstrap';

import DownloadLink from '../../common/DownloadLink';

export default function ButtonsCard({ projId, scrollTo, switchToReadMode,...rest }) {
  const {isRequestPending}=rest;

  return (
    <Card>
      <Card.Body className="p-4">
        <Row>
          <Form.Group as={Col}>
            {!!projId && <Button className="me-2" onClick={switchToReadMode} variant="outline-secondary">Отмена</Button>}
            <Button disabled={isRequestPending} className="me-2" variant="primary" type="submit">Сохранить</Button>
            {/* {!readonly && <Button className="me-2" variant="outline-primary">Сохранить черновик</Button>} */}
            {/* {!readonly && <Button className="me-2" disabled variant="outline-danger">Удалить</Button>} */}
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
}
